/**
 * Created by Ivan on 17.10.2024
 */

const OpenLetterBooster = function (id) {
    Booster.call(this, id);
    this.setState(OpenLetterBooster.INACTIVE);
};

OpenLetterBooster.prototype = Object.create(Booster.prototype);
OpenLetterBooster.prototype.constructor = OpenLetterBooster;

OpenLetterBooster.prototype.onExecute = function () {
    this.setState(OpenLetterBooster.ACTIVE);

    Game.currentGame.keypad.chooseBoosterLetter();
};

OpenLetterBooster.prototype.isActive = function () {
    return this.state === OpenLetterBooster.ACTIVE;
};

OpenLetterBooster.prototype.isAnimating = function () {
    return this.state === OpenLetterBooster.ANIMATION;
};

OpenLetterBooster.prototype.setState = function (state) {
    this.state = state;
};

OpenLetterBooster.prototype.open = function (letter) {
    this.setState(OpenLetterBooster.ANIMATION);

    if (!this.canExecute() && !this._buy()) {
        this.afterExecute(0);
        this.trigger("afterExecute", true);
        return;
    }

    const hintAnimationDuration = 0.3;
    const hintAnimationTimeout = hintAnimationDuration + 0.5;

    const letters = Game.currentGame.board.selectLettersPositions(letter.symbol);
    let maxDelay = 0;

    letters.forEach((pos) => {
        const delay = pos[1] * 100 + 750;

        cleverapps.timeouts.setTimeout(() => {
            Game.currentGame.board.addHint(pos[0], pos[1], cleverapps.Board.SPAWN_LETTER_ANIMATION);
        }, delay);

        maxDelay = Math.max(delay, maxDelay);
    });

    this.use(this.useType);

    this.afterExecute(maxDelay + hintAnimationTimeout * 1000);
    this.trigger("afterExecute");
};

OpenLetterBooster.prototype.cancel = function () {
    this.setState(OpenLetterBooster.ANIMATION);

    this.afterExecute(500);
    this.trigger("afterExecute", true);
};

OpenLetterBooster.prototype.execute = function (useType) {
    this.useType = useType;

    this.onExecute();
    this.onExecuteListener();
    cleverapps.tutorial.trigger("executeOpenLetterBooster");
};

OpenLetterBooster.prototype.afterExecute = function (timeout) {
    Game.currentGame.counter.setTimeout(() => {
        this.setState(OpenLetterBooster.INACTIVE);
        Game.currentGame.keypad.openLetterChoosed();
    }, timeout);
};

OpenLetterBooster.prototype._buy = BaseBooster.prototype.buy;
OpenLetterBooster.prototype.buy = function () {
    const canBuy = cleverapps.user.canTakeHard(this.getPrice().amount);
    if (!canBuy) {
        cleverapps.user.onCantTakeGold();
    }
    return canBuy;
};

OpenLetterBooster.INACTIVE = 0;
OpenLetterBooster.ACTIVE = 1;
OpenLetterBooster.ANIMATION = 2;